import { Constant } from '../../../../Autofacets-Core/src/app/utils/constant';

export class Filter {
  skip: number;
  page: number;
  pageSize: number;
  search: string;
  sortfield: string;
  sortOrder: string;
  searchField: string;
  status: string;
  type: string;
  startDate: string;
  endDate: string;
  contractId: string;
  supplierId: string;
  licencePlate: string;

  constructor() {
    this.skip = 0;
    this.page = 1;
    this.pageSize = Constant.GridPagerSize;
    this.search = '';
    this.sortfield = '';
    this.sortOrder = 'DESC';
    this.searchField = '';
    this.status = '';
    this.type = '';
    this.startDate = '';
    this.endDate = '';
    this.contractId = '';
    this.supplierId = '';
    this.licencePlate = '';
  }

  public convertToString(): string {
    return '?take=' + this.pageSize.toString() +
      '&skip=' + this.skip.toString() +
      '&page=' + this.page.toString() +
      '&pageSize=' + this.pageSize.toString() +
      '&search=' + this.search +
      '&sortfield=' + this.sortfield +
      '&searchField=' + this.searchField +
      '&sortOrder=' + this.sortOrder +
      '&status=' + this.status +
      '&type=' + this.type +
      '&startDate=' + this.startDate +
      '&endDate=' + this.endDate +
      '&contractId=' + this.contractId +
      '&supplierId=' + this.supplierId +
      '&licencePlate=' + this.licencePlate;
  }
}
